import React, { useEffect, useState } from "react";
import {
  Table, Card, Row, useDispatch, useSelector, Select,
  CheckOutlined, CloseOutlined, Col, Input, Button, Divider, Radio, DeleteFilled, EditFilled, SearchOutlined, UserAddOutlined
} from '../../AntComponent';
import { useNavigate } from 'react-router-dom';
import { serviceRefGrid, userTypeRoleDpdn } from "../../../store/actions/security/serviceRefAction";


export default function ServiceManagement() {

  const history = useNavigate();
  const dispatch = useDispatch();
  const { srvTableData, typeRoleDpd } = useSelector(state => state.serviceRef);
  const tableData = srvTableData?.data.userTypeServiceLists || [];
  const [userType, setUserType] = useState();
  const [loadFirst, setLoadFirst] = useState(true);
  const { profileInfo } = useSelector(state => state.userPrf);
  const tenantID = profileInfo?.data?.appUser?.tenantID;
  const appUserID = profileInfo?.data?.appUser?.appuserID;
  const productID = profileInfo?.data?.tenantDetail?.kProductID;
  const typeRoleData = typeRoleDpd?.data?.map((item,i) => {
    return (
      {
        label: item.userType,
        value: item.userTypeID,
        key: i
      }
      )
    });

  function userTypeRole() {
    let id = `${productID}/${tenantID}`;
    dispatch(userTypeRoleDpdn(id));
  }

  useEffect(() => {
    if (tenantID) {
      userTypeRole();
    }
  }, [dispatch, tenantID]);

  useEffect(() => {
    if (typeRoleDpd?.data && loadFirst) {
      setUserType(typeRoleDpd?.data[0]?.userTypeID);
      serviceGrid(typeRoleDpd?.data[0]?.userTypeID);
      setLoadFirst(false);
    }
  }, [typeRoleData]);

  function serviceGrid(id) {
    let inputJson = {
      "UserTypeParams": {
        "UserTypeID": id,
        "ProductId": productID
      },
      "ServerSearchables": {
        "draw": 1,
        "searchData": "",
        "orderByColumn": "GlobalOrderBy",
        "orderBy": "asc",
        "currentPage": 0,
        "pageSize": 10,
        "pageNumber": 1
      },
      "userTypeServiceLists": []
    }
    dispatch(serviceRefGrid(inputJson));
  }


  const columns1 = [
    {
      title: 'Service Name',
      dataIndex: 'servicename',
      key: 'servicename',
    },
    {
      title: 'Read',
      dataIndex: 'read',
      key: 'read',
    },
    {
      title: 'Write',
      dataIndex: 'write',
      key: 'write',
    },
    {
      title: 'Delete',
      dataIndex: 'delete',
      key: 'delete',
    },
    {
      title: 'Approve',
      dataIndex: 'approve',
      key: 'approve',
    },
    {
      title: 'Export',
      dataIndex: 'export',
      key: 'export',
    },
    {
      title: 'Data Condition',
      dataIndex: 'datacondition',
      key: 'datacondition',
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
  ];


  return (
    <>
      <div className="mt-2  py-3 pb-5">
        <Card className="border-0">
          <div className='row ps-4 pe-3 mb-2'>
            <div className='col text-start ms-1 my-auto d-flex'>
              <h6 className="mb-0">Available Search for User Type</h6>
              <sup><Select className="ms-2 col-md-auto" bordered={false} options={typeRoleData} value={userType} onChange={(e) => {setUserType(e); serviceGrid(e)}}  />
              </sup>
            </div>
          </div>
          <div className="mt-2">
            <table className="w-100 ">
              <thead>
                <tr >
                  <th className="text-white">Service Name</th>
                  <th className="text-center text-white">Read</th>
                  <th className="text-center text-white">Write</th>
                  <th className="text-center text-white">Delete</th>
                  <th className="text-center text-white">Approve</th>
                  <th className="text-center text-white">Export</th>
                  <th className="text-white">Data Condition</th>
                  <th className="text-white">Description</th>
                </tr>
              </thead>
              <tbody className="mt-2">
                {tableData?.map((item) => {
                  return (
                    <React.Fragment key={item.entServiceId}>
                      <tr className="border-bottom" >
                        <td className="tr-title bck-clr p-2">
                          <div>{item.serviceName}</div>
                        </td>
                        <td className="tr-title bck-clr p-2">
                        </td>
                        <td className="tr-title bck-clr p-2"></td>
                        <td className="tr-title bck-clr p-2"></td>
                        <td className="tr-title bck-clr p-2"></td>
                        <td className="tr-title bck-clr p-2"></td>
                        <td className="tr-title bck-clr p-2"></td>
                        <td className="tr-title bck-clr p-2"></td>
                      </tr>
                      {item?.subMenu?.map((itm) => {
                        return (
                          <tr className="border-bottom p-2" key={itm.entServiceId}>
                            <td className="text-end border-end pe-3">{itm.serviceName}</td>
                            <td className="text-center border-end">{itm.read_Attri ? <CheckOutlined className="text-success" /> : <CloseOutlined />}</td>
                            <td className="text-center border-end">{itm.write_Attri ? <CheckOutlined className="text-success" /> : <CloseOutlined />}</td>
                            <td className="text-center border-end">{itm.delete_Attri ? <CheckOutlined className="text-success" /> : <CloseOutlined />}</td>
                            <td className="text-center border-end">{itm.approve_Attri ? <CheckOutlined className="text-success" /> : <CloseOutlined />}</td>
                            <td className="text-center border-end">{itm.export_Attri ? <CheckOutlined className="text-success" /> : <CloseOutlined />}</td>
                            <td className="text-center border-end">{itm.datacond}</td>
                            <td className="text-center border-end">{itm.description}</td>
                          </tr>
                        )
                      })}
                    </React.Fragment>)
                })}
              </tbody>
            </table>
          </div>
        </Card>
      </div>
    </>
  )
}


